import React, { useEffect } from 'react';
import { useTopicStore } from './store';
import ThinkingIndicator from '../../components/ThinkingIndicator';

interface WikipediaTabV2Props {
  topicId?: string | null;
  viewportWikiLanguage: string;
  userPreferredWikiLangCode?: string;
}

export default function WikipediaTabV2({
  topicId,
  viewportWikiLanguage,
  userPreferredWikiLangCode,
}: WikipediaTabV2Props) {
  const fetchWikipediaEmbed = useTopicStore((s) => s.fetchWikipediaEmbed);
  const wikipediaEmbed = useTopicStore((s) => {
    if (!topicId) return null;
    return s.topics[topicId]?.wikipediaEmbed ?? null;
  });

  useEffect(() => {
    if (!topicId) return;
    if (wikipediaEmbed?.isLoading) return;
    if (wikipediaEmbed?.url && wikipediaEmbed?.preferredLang === (userPreferredWikiLangCode || 'en')) return;

    void fetchWikipediaEmbed(topicId, { viewportWikiLanguage, userPreferredWikiLangCode });
  }, [
    topicId,
    viewportWikiLanguage,
    userPreferredWikiLangCode,
    wikipediaEmbed?.isLoading,
    wikipediaEmbed?.url,
    wikipediaEmbed?.preferredLang,
    fetchWikipediaEmbed,
  ]);

  const isLoading = !!wikipediaEmbed?.isLoading;
  const error = wikipediaEmbed?.error ?? null;
  const wikipediaUrl = wikipediaEmbed?.url ?? null;

  return (
    <div className="wikipedia-section" style={{ width: '100%', height: '70vh', position: 'relative' }}>
      {isLoading && (
        <ThinkingIndicator style={{ padding: '10px' }} />
      )}
      {error && <div style={{ color: '#666', padding: '10px' }}>{error}</div>}
      {wikipediaUrl && !isLoading && (
        <div style={{ width: '100%', height: '100%', overflow: 'hidden', background: '#1f2937' }}>
          <iframe
            src={wikipediaUrl}
            title="Wikipedia Article"
            style={{
              border: 'none',
              width: '125%',
              height: '144%',
              transform: 'scale(0.8)',
              transformOrigin: '0 0',
              background: '#1f2937',
            }}
            loading="lazy"
          />
        </div>
      )}
    </div>
  );
}
